import type React from "react";
import type { EntityRef } from "@common/schemas/chatEntityRef.schema";

export interface EntityRefOption {
    key: string;
    entityRef: EntityRef;
    icon: React.ReactNode;
    title: string;
    description?: string;
}

export interface EntityRefOptionsResult {
    options: EntityRefOption[];
    isLoading: boolean;
}

export interface EntityRefOptionsParams {
    query: string;
    isEnabled: boolean;
}

export const MAX_ENTITY_REF_OPTIONS = 8;

export const NO_ENTITY_REF_OPTIONS: EntityRefOptionsResult = {
    options: [],
    isLoading: false,
};
